import React from 'react';
import './styles.scss';

interface Props {
  title: string;
	mobiletitle: string;
	description: string;
  slides_shapes: string;
  slides_to_show: string;
  banner_top_shadow: string;
  banner_top_shadow_opacity: string;
  banner_bottom_shadow: string;
  banner_bottom_shadow_opacity: string;
  paragraphId: string;
  sub_heading: string;
  title_font_color: string;
}

const Heading: React.FC<Props> = ({title, mobiletitle, description, slides_to_show, banner_top_shadow, paragraphId,banner_top_shadow_opacity, banner_bottom_shadow, banner_bottom_shadow_opacity, slides_shapes, sub_heading, title_font_color }) => {
  return (
    <div className="card-heading text-center">
      <div className="card-header">
        {title ? <h2 className="desktop dynamic-title" style={{color: title_font_color }}>{title}</h2> : "" }
        {mobiletitle ? <h2 className="mobile dynamic-title" style={{color: title_font_color }}>{mobiletitle}</h2> : "" }
        {sub_heading ? <h4 className="sub-heading dynamic-title" dangerouslySetInnerHTML={{
                  __html: sub_heading,
                }} />  : "" }
      </div>
      {description ? <div className="card-footer dynamic-description" dangerouslySetInnerHTML={{
                  __html: description,
                }} />
        : "" }
    </div>
  );
};

export default Heading;
